import {
	Popover,
	PopoverButton,
	PopoverPanel,
} from "@headlessui/react";
import { BarsIcon } from "assets/icons/BarsIcon";
import { CloseIcon } from "assets/icons/CloseIcon";
import LogoLg from "assets/images/Logo_lg_colo.svg";
import LogoSm from "assets/images/Logo_sm_color.svg";
import { useEffect, useState } from "react";
import { MenuData } from "assets/data/MenuData";
import { NavLink } from "react-router-dom";

export const Header = () => {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const isScrolled =
				document.body.scrollTop >= 50 ||
				document.documentElement.scrollTop >= 50;
			setScrolled(isScrolled);

			const MenuLg = document.getElementById("lg-menu");
			if (MenuLg) {
				if (isScrolled) {
					MenuLg.classList.add("menu-lg-bg");
				} else {
					MenuLg.classList.remove("menu-lg-bg");
				}
			}
		};

		handleScroll();
		window.addEventListener("scroll", handleScroll);
		window.scrollTo(0, 0);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	const navLinkClass = ({ isActive }) =>
		`text-base font-medium duration-300 outline-none relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:duration-300 hover:after:w-full ${
			isActive ? "text-primary after:w-full" : "text-secondary hover:text-primary"
		}`;

	return (
		<header
			id="header"
			className={`fixed w-full z-999 transition-all duration-500 ${
				scrolled ? "glass-header py-2" : "bg-transparent py-3"
			}`}
		>
			<div className="container">
				<div className="w-full flex items-center gap-4 lg:gap-6">
					<NavLink to="/" className="w-36 lg:w-48 shrink-0 duration-300 hover:opacity-90">
						<img
							src={LogoLg}
							className="w-full hidden md:block"
							alt="Adroit Systems"
						/>
						<img
							id="small-logo"
							src={LogoSm}
							className="md:hidden w-16"
							alt="Adroit Systems"
						/>
					</NavLink>

					<div className="grow flex lg:justify-center items-center lg:flex-row flex-row-reverse">
						<div
							id="lg-menu"
							className="hidden lg:flex items-center gap-8 py-2.5 px-6 transition-all duration-500"
						>
							{MenuData.map((menu, index) => {
								if (menu.subItems.length === 0) {
									return (
										<NavLink
											key={index}
											to={menu.url}
											className={navLinkClass}
										>
											{menu.title}
										</NavLink>
									);
								}

								return (
									<Popover key={index}>
										{({ open }) => (
											<>
												<PopoverButton
													className={`text-base font-medium outline-none duration-300 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:duration-300 hover:after:w-full ${
														open
															? "text-primary after:w-full"
															: "text-secondary hover:text-primary"
													}`}
												>
													{menu.title}
												</PopoverButton>
												<PopoverPanel
													transition
													anchor="bottom start"
													className="z-999 mt-2 shadow-lg data-[closed]:opacity-0 data-[closed]:scale-95 rounded-2xl ease-out duration-200 p-2 bg-white border border-gray-100 flex flex-col min-w-[200px]"
												>
													{({ close }) =>
														menu.subItems.map(
															(item, subIndex) => (
																<NavLink
																	key={subIndex}
																	to={item.url}
																	className="px-4 py-2.5 rounded-xl text-sm text-secondary hover:text-primary hover:bg-primary/5 duration-300"
																	onClick={() =>
																		close()
																	}
																>
																	{item.title}
																</NavLink>
															)
														)
													}
												</PopoverPanel>
											</>
										)}
									</Popover>
								);
							})}
						</div>

						<div className="lg:hidden">
							<Popover>
								{({ open }) => (
									<>
										<PopoverButton className="outline-none p-1 rounded-lg hover:bg-gray-100 duration-300">
											{open ? (
												<CloseIcon className="size-8 text-primary" />
											) : (
												<BarsIcon className="size-8" />
											)}
										</PopoverButton>
										<PopoverPanel
											transition
											className="absolute shadow-xl bg-white/95 backdrop-blur-lg w-screen left-0 top-[72px] py-6 px-4 lg:hidden duration-300 data-[closed]:opacity-0 data-[closed]:-translate-y-2 ease-out border-b border-gray-100"
										>
											{({ close }) =>
												MenuData.map((menu, index) => (
													<div
														key={index}
														className="mb-4 last:mb-0"
													>
														{menu.subItems.length ===
														0 ? (
															<NavLink
																to={menu.url}
																className="block text-lg font-semibold text-primary py-2"
																onClick={() =>
																	close()
																}
															>
																{menu.title}
															</NavLink>
														) : (
															<>
																<h6 className="text-sm uppercase tracking-wider text-gray-400 font-semibold mb-2 px-2">
																	{menu.title}
																</h6>
																<div className="flex flex-col">
																	{menu.subItems.map(
																		(
																			item,
																			subIndex
																		) => (
																			<NavLink
																				key={
																					subIndex
																				}
																				className="px-4 py-2.5 rounded-xl hover:text-primary hover:bg-primary/5 duration-300"
																				to={
																					item.url
																				}
																				onClick={() =>
																					close()
																				}
																			>
																				{
																					item.title
																				}
																			</NavLink>
																		)
																	)}
																</div>
															</>
														)}
													</div>
												))
											}
										</PopoverPanel>
									</>
								)}
							</Popover>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};
